import { render, staticRenderFns } from "./printProductDetailsSection.vue?vue&type=template&id=1a3ceda8&"
import script from "./printProductDetailsSection.vue?vue&type=script&lang=tsx&"
export * from "./printProductDetailsSection.vue?vue&type=script&lang=tsx&"
import style0 from "./printProductDetailsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports